import { GET_CART, DELETE_CART } from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";

const cleanFirestoreData = (value) => {
  if (Array.isArray(value)) {
    return value
      .filter((item) => item !== undefined)
      .map((item) => cleanFirestoreData(item));
  }

  if (value && typeof value === "object") {
    return Object.entries(value).reduce((cleaned, [key, item]) => {
      if (item !== undefined) {
        cleaned[key] = cleanFirestoreData(item);
      }
      return cleaned;
    }, {});
  }

  return value;
};

export const getCart = (props) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(`users/${userId}/cart`);
    dataRef
      .get()
      .then((documentSnapshots) => {
        var docs = documentSnapshots.docs;
        var lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        var dataArray = [];
        docs.map((item) => {
          var newOrder = {
            key: item.id,
            id: item.id,
            ...item.data(),
          };
          dataArray.push(newOrder);
        });

        dispatch({ type: GET_CART, payload: { dataArray: dataArray } });
      })
      .catch((err) => {
        console.log("ERROR CART");
        if (err.code == "permission-denied") {
          dispatch({ type: "LOGOUT", payload: null });
          firebase.auth().signOut();
        }
        console.log(err.code);
      });
  };
};

export const addCartItem = (data) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var cartid = `${data.product}_${userId}`;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(`users/${userId}/cart`);

    return dataRef.doc(cartid).set(cleanFirestoreData({ ...data, unit: typeof data.unit === "string" && data.unit.trim() ? data.unit.trim() : "unit" }));
  };
};

export const editCartItem = (data, id) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(`users/${userId}/cart`);
    return dataRef.doc(id).set(cleanFirestoreData(data), { merge: true });
  };
};

export const deleteCartItem = (id) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var Firestore = firebase.firestore();
    var CartRef = Firestore.collection(`users/${userId}/cart`);
    return CartRef.doc(id).delete();
  };
};

export const clearCart = () => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var cartData = reduxState.cart.data;

    var Firestore = firebase.firestore();
    var batch = firebase.firestore().batch();
    var CartRef = Firestore.collection(`users/${userId}/cart`);

    var waiting = await Promise.all(
      cartData.map(async (indx) => {
        var waitdelete = await CartRef.doc(indx.id).delete();
      })
    );
    dispatch({ type: GET_CART, payload: { dataArray: [] } });
    return "cartCleared";
  };
};
